import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'video_mng',
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '病害任务管理',
        addFunName: 'taskAdd',
        modifyFunName: 'taskModify',
        handleFunName: 'taskHandle',
        queryFunName: 'taskQuery',
        detailFunName: 'taskDetail',
        delFunName: 'taskDel'
      },
      searchForm: {
        page: 1,
        limit: 10,
        videoName: null,
        sortField: 'create_time',
        category: 'Disease'
      },
      formData: {
        category: 'Disease',
        executeUser: localStorage.getItem('userId'),
        executeUserNickname: localStorage.getItem('userNickname'),
        executeDate: dayjs().format('YYYY-MM-DD HH:mm:ss')
      },
      rules: {
        labId: [{
          required: true,
          message: '请选择企业',
          trigger: 'blur'
        }],
        areaId: [{
          required: true,
          message: '请选择养殖区域',
          trigger: 'blur'
        }],
        executeDate: [{
          required: true,
          message: '请选择执行日期',
          trigger: 'blur'
        }],
        executeUser: [{
          required: true,
          message: '请选择执行人',
          trigger: 'blur'
        }],
        category: [{
          required: true,
          message: '请输入任务类别',
          trigger: 'blur'
        }],
        executeContent: [{
          required: true,
          message: '请输入执行内容',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {},
      lab_show: false,
      area_show: false,
      user_show: false,
      handleDialogShow: false,
      handleData: {},
      handleRules: {
        operateDate: [{
          required: true,
          message: '请选择操作日期',
          trigger: 'blur'
        }],
        operateContent: [{
          required: true,
          message: '请输入操作内容',
          trigger: 'blur'
        }]
      },
      plan_show: false
    };
  },
  components: {
    labSel: function labSel() {
      return import('../org/lab_sel.vue');
    },
    areaSel: function areaSel() {
      return import('../org/lab_area_sel_task.vue');
    },
    userSel: function userSel() {
      return import('../user/user_sel.vue');
    },
    planSel: function planSel() {
      return import('./plan_sel.vue');
    }
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.query();
  },
  methods: {
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (data.executeDate) {
        paramData.executeDate = dayjs(data.executeDate).format('YYYY-MM-DD HH:mm:ss');
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this = this;
      this.$api[this.pageConfig.detailFunName](id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _this.initFormData(res.data);
                _this.editDialogTitle = _this.pageConfig.editPageName + '维护';
                _this.editDialogShow = true;
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handle: function handle(id) {
      this.handleData = {
        id: id,
        operateDate: this.dayjs().format('YYYY-MM-DD HH:mm:ss')
      };
      this.handleDialogShow = true;
    },
    del: function del(id) {
      var _this2 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this2.$api[_this2.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this2.$message.success('删除成功');
            _this2.query();
          } else {
            _this2.$message.error('删除失败');
          }
        });
      });
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
        this.$set(this.formData, 'areaId', '');
        this.$set(this.formData, 'areaName', '');
        this.$set(this.formData, 'planId', null);
        this.$set(this.formData, 'batchCode', '');
      }
      this.lab_show = false;
    } // 选择养殖区域
    ,
    areaClick: function areaClick() {
      if (!this.formData.labId) {
        this.$message.info('请先选择所属企业');
        return;
      }
      this.area_show = true;
    },
    areaSel: function areaSel(data) {
      if (data) {
        this.$set(this.formData, 'areaId', data.id);
        this.$set(this.formData, 'areaName', data.name);
        this.$set(this.formData, 'planId', null);
        this.$set(this.formData, 'batchCode', '');
      }
      this.area_show = false;
    } // 选择消息接收人
    ,
    userClick: function userClick(val) {
      this.userIdx = val;
      this.user_show = true;
    },
    userSel: function userSel(val) {
      if (val) {
        this.$set(this.formData, 'executeUserNickname', val.nickname);
        this.$set(this.formData, 'executeUser', val.id);
      }
      this.user_show = false;
    } // 选择养殖计划
    ,
    planClick: function planClick() {
      if (!this.formData.labId) {
        this.$message.info('请先选择所属企业');
        return;
      }
      if (!this.formData.areaId) {
        this.$message.info('请先选择所属养殖区域');
        return;
      }
      this.plan_show = true;
    },
    planSel: function planSel(val) {
      if (val) {
        this.$set(this.formData, 'planId', val.id);
        this.$set(this.formData, 'batchCode', val.batchCode);
      }
      this.plan_show = false;
    },
    query: function query() {
      var _this3 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this3.tableData = res.data || [];
        _this3.totalCount = res.count;
        _this3.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this4 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this4.formData.id) {
            _this4.$api[_this4.pageConfig.modifyFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('编辑成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('编辑失败');
              }
            });
          } else {
            _this4.$api[_this4.pageConfig.addFunName](_this4.saveFormDataProcess(_this4.formData)).then(function (res) {
              if (res.data) {
                _this4.$message.success('新增成功');
                _this4.initFormData(_this4.emptyFormData);
                _this4.editDialogShow = false;
                _this4.query();
              } else {
                _this4.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    submitHandleData: function submitHandleData() {
      var _this5 = this;
      this.$refs['handleformDataVerify'].validate(function (valid) {
        if (valid) {
          _this5.$api[_this5.pageConfig.handleFunName](_this5.handleData.id, _this5.saveFormDataProcess(_this5.handleData)).then(function (res) {
            if (res.data) {
              _this5.$message.success('操作成功');
              _this5.handleDialogShow = false;
              _this5.handleData = {};
              _this5.query();
            } else {
              _this5.$message.error('操作失败');
            }
          });
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};